
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { replaceComma } from "@common/src/utils/verify";
import { Table } from "@common/src/utils/decorator";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";

const finance = namespace("finance");
@Component({})
@Table("loadListData")
export default class ReceiptOrder extends Vue {
  @finance.Action getReceiptDetail;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  replaceComma = replaceComma;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  fissionPayment = [
    {
      paidMethodDesc: t("v210801.bank-transfer"),
      paidAmount: null
    }
  ];
  arrayProductCodes(row) {
    return row.productCodes.split(",");
  }
  get breadData() {
    return [{ name: t("finance.receipt"), path: "/finance/collection-order" }, { name: t("finance.receipt-details") }];
  }
  get receiptId() {
    return this.$route.params.id;
  }
  get receiptType() {
    return String(this.detailData.receiptType);
  }

  get showOrderInfo() {
    return this.receiptType !== "9" && this.receiptType !== "4" && this.receiptType !== "7";
  }

  handleLinkServiceView(row) {
    let type = row.orderNo.slice(0, 2);
    let url = "";
    if (type === "CG") {
      url = "/purchase/purchase-view/";
    } else if (type === "TH") {
      url = "/purchase/purchase-refund-view/";
    } else {
      url = "/service/view/";
    }
    let { href } = this.$router.resolve({
      path: url + row.orderNo
    });
    window.open(href, "_blank");
  }
  orderList: any[] = [];
  fissionOrderList: any[] = [];
  detailData: any = {};
  created() {
    this.init();
  }
  init() {
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getReceiptDetail({
      receiptNo: this.receiptId,
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.detailData = data.data;
      if (data.data.paidProof) {
        this.fissionPayment[0].paidAmount = data.data.paidProof.paidAmount;
      }
      this.orderList = data.data.orderList;
      this.fissionOrderList = data.data.fissionOrderSummaries || [];
      if (this.detailData.discountList) {
        this.detailData.discountList.forEach(ele => {
          if (ele.discountMethod == 5) {
            ele.Package_card_collection = this.Subtr(ele.discountAmount, ele.realPaidAmount);
          }
        });
      }
      return data.data.orderTotalCount;
    });
  }
  handleLinkView(item) {
    const { href } = this.$router.resolve(`/marketing/card-view/${this.replaceComma(item)}`);
    window.open(href);
  }
  Subtr(arg1, arg2) {
    let r1, r2, m, n;
    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = r1 >= r2 ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  }
  get showDeferredArea() {
    return this.receiptType === "7";
  }
}
